import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CRow,
  CCol
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class UsersModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // loading: true,
      selectedUsers: [],
      administrator: [
        { value: true, label: "Administrador" },
        { value: false, label: "Membro" }
      ],
      users: []
    };
  }

  onOpen() {
    if (this.props.users) {
      this.setState({ selectedUsers: this.props.users });
    }
  }

  componentDidMount() {
    const user = JSON.parse(localStorage.getItem("persist:root"));
    let aux = user.user.replaceAll(" ", "");
    let groupID = aux.split("group_id")[1].split(":")[1].split(",")[0];
    axios
      .get(`${URL.api}access/user/searchUsers`, {
        params: { group_id: groupID },
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respUsers => {
          let optionsUsers = [];
          respUsers.data.data.forEach(user => {
            optionsUsers.push({ value: user, label: user.name });
          });
          this.setState({ users: optionsUsers });
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  addUser() {
    this.setState(state => {
      const prev = [...state.selectedUsers];
      prev.push({ user: { id: null }, administrator: null });

      return { selectedUsers: prev };
    });
  }

  removeUser(index) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev.splice(index, 1);

      return { selectedUsers: prev };
    });
  }

  changeUser(index, value) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev[index].user = value;

      return { selectedUsers: prev };
    });
  }

  changeAdministrator(index, value) {
    this.setState(state => {
      let prev = [...state.selectedUsers];
      prev[index].administrator = value;

      return { selectedUsers: prev };
    });
  }

  render() {
    return (
      <CModal
        show={this.props.show}
        size="lg"
        onClose={() => this.props.onClose()}
        onOpened={() => this.onOpen()}
      >
        <CModalHeader>
          <CModalTitle>Selecione os usuários</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <>
            {this.state.selectedUsers.map((item, index) => (
              <CRow key={index}>
                <CCol xs="6">
                  <CFormGroup>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-user"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        isSearchable
                        placeholder="Escolha um membro"
                        name="Membro"
                        options={this.state.users}
                        defaultValue={this.state.users.find(
                          option => option.value.id === item.user.id
                        )}
                        value={this.state.users.find(
                          option => option.value.id === item.user.id
                        )}
                        classNamePrefix="select"
                        onChange={e => this.changeUser(index, e.value)}
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
                <CCol xs="5">
                  <CFormGroup>
                    <CInputGroup className="input-prepend">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-id-card-o"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <Select
                        placeholder="Tipo"
                        name="Tipo"
                        options={this.state.administrator}
                        defaultValue={this.state.administrator.find(
                          option => option.value === item.administrator
                        )}
                        value={this.state.administrator.find(
                          option => option.value === item.administrator
                        )}
                        classNamePrefix="select"
                        onChange={e => this.changeAdministrator(index, e.value)}
                      />
                    </CInputGroup>
                  </CFormGroup>
                </CCol>
                <CCol xs="1">
                  <CButton
                    variant="outline"
                    color="secondary"
                    className="text-dark"
                    onClick={() => this.removeUser(index)}
                  >
                    <i className="fa fa-trash"></i>
                  </CButton>
                </CCol>
              </CRow>
            ))}
            <CButton
              variant="outline"
              color="secondary"
              className="text-dark"
              onClick={() => this.addUser()}
            >
              Adicionar
            </CButton>
          </>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-end">
          <CButton
            color="primary"
            className="mr-2"
            onClick={() => this.props.onClose(this.state.selectedUsers)}
          >
            Salvar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersModal);
